module.exports = __webpack_public_path__ + "7d088296/img/copy-icon.408fdb2d.svg";